const InvitedStatusBlueIcon = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: any;
  onClick?: any;
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33325 2.66683C3.15644 2.66683 2.98687 2.73707 2.86185 2.86209C2.73682 2.98712 2.66659 3.15668 2.66659 3.3335V12.3907L4.19518 10.8621C4.32021 10.7371 4.48977 10.6668 4.66659 10.6668H12.6666C12.8434 10.6668 13.013 10.5966 13.138 10.4716C13.263 10.3465 13.3333 10.177 13.3333 10.0002V3.3335C13.3333 3.15669 13.263 2.98712 13.138 2.86209C13.013 2.73707 12.8434 2.66683 12.6666 2.66683H3.33325ZM1.91904 1.91928C2.29411 1.54421 2.80282 1.3335 3.33325 1.3335H12.6666C13.197 1.3335 13.7057 1.54421 14.0808 1.91928C14.4559 2.29436 14.6666 2.80306 14.6666 3.3335V10.0002C14.6666 10.5306 14.4559 11.0393 14.0808 11.4144C13.7057 11.7894 13.197 12.0002 12.6666 12.0002H4.94273L2.47132 14.4716C2.28066 14.6622 1.99391 14.7193 1.7448 14.6161C1.49568 14.5129 1.33325 14.2698 1.33325 14.0002V3.3335C1.33325 2.80306 1.54397 2.29436 1.91904 1.91928Z"
        fill="#267591"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99992 4C8.36811 4 8.66659 4.29848 8.66659 4.66667V8.66667C8.66659 9.03486 8.36811 9.33333 7.99992 9.33333C7.63173 9.33333 7.33325 9.03486 7.33325 8.66667V4.66667C7.33325 4.29848 7.63173 4 7.99992 4Z"
        fill="#267591"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33325 6.66667C5.33325 6.29848 5.63173 6 5.99992 6H9.99992C10.3681 6 10.6666 6.29848 10.6666 6.66667C10.6666 7.03486 10.3681 7.33333 9.99992 7.33333H5.99992C5.63173 7.33333 5.33325 7.03486 5.33325 6.66667Z"
        fill="#267591"
      />
    </svg>
  );
};

export default InvitedStatusBlueIcon;
